var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4"},[_c('v-card-title',[_c('h2',[_vm._v("Moje opinie formalne")])]),_c('formal-evaluation-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }